/**
 * Filtre local par chargé de clientèle — évite un appel API à chaque changement
 * de select (le board complet est chargé une fois, filtré côté client).
 */
export const filterPipelineByCdc = (pipeline, chargeFiltre) => {
  if (!chargeFiltre) {
    return pipeline;
  }
  const colonnes = {};
  Object.entries(pipeline.colonnes || {}).forEach(([key, cards]) => {
    colonnes[key] = (cards || []).filter((c) => c.account_manager === chargeFiltre);
  });
  return {
    ...pipeline,
    aQualifier: (pipeline.aQualifier || []).filter(
      (e) => e.charge_de_clientele === chargeFiltre
    ),
    colonnes,
  };
};

export const filterSavsByCdc = (savs, chargeFiltre) => {
  if (!chargeFiltre) {
    return savs || [];
  }
  return (savs || []).filter((s) => s.charge_de_clientele === chargeFiltre);
};
